<script lang="ts" setup>
import { sharePlatform } from '~/config/sharePlatform';
import { useRouter } from 'vue-router';
import { PropType } from 'vue';
import { usePopup } from '~/store/usePopup';

const isOpen = ref<boolean>(true);

const config = useRuntimeConfig();
const router = useRouter();
const popupStore = usePopup();

function share(url: string) {
  const shortlinkId = router.currentRoute.value.params.shortlinkId;
  window.open(
    `${url}${config.public.baseUrl}/vacancy/${shortlinkId}`,
    '_blank'
  );
}

function mobileOpenHandle() {
  isOpen.value = !isOpen.value;
}

defineProps({
  title: {
    type: String as PropType<string>,
    required: true,
  },
  description: {
    type: String as PropType<string>,
    required: true,
  },
});

function copy() {
  navigator.clipboard.writeText(window.location.href);
  popupStore.open = true;
  popupStore.modalError = false;
  popupStore.modalText = 'Text copied to clipboard';
}
</script>
<template>
  <div
    class="fixed lg:absolute top-[20px] left-0 lg:top-[50px] lg:left-[-60px] cursor-pointer z-20"
  >
    <button
      type="button"
      class="bg-white h-[48px] w-[48px] flex justify-center items-center right-0 top-[100px] shadow-md rounded-r-[10px] lg:rounded-[10px] z-50"
      @click="mobileOpenHandle"
      aria-label="share"
      tabindex="3"
    >
      <MyIcon icon="mdiShareVariantOutline" color="#000000" />
    </button>

    <div
      class="shadow-md rounded-[10px] w-[48px] overflow-hidden fixed left-0 lg:top-[60px] lg:absolute"
      v-if="isOpen"
    >
      <button
        type="button"
        v-for="{ url, icon, color, aria, tabindex } in sharePlatform"
        :style="{ backgroundColor: color }"
        class="h-[48px] w-[48px] flex justify-center items-center"
        @click="share(url)"
        :aria-label="aria"
        :tabindex="tabindex"
      >
        <MyIcon
          :icon="icon"
          color="#ffffff"
          class="hover:scale-125 duration-500"
        />
      </button>
      <button
        type="button"
        class="h-[48px] w-[48px] flex justify-center items-center bg-black"
        @click="share('https://twitter.com/share?url=')"
        aria-label="twitter"
        tabindex="6"
      >
        <svg
          class="h-[20px] fill-white"
          xmlns="http://www.w3.org/2000/svg"
          shape-rendering="geometricPrecision"
          text-rendering="geometricPrecision"
          image-rendering="optimizeQuality"
          fill-rule="evenodd"
          clip-rule="evenodd"
          viewBox="0 0 512 462.799"
        >
          <path
            fill-rule="nonzero"
            d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"
          />
        </svg>
      </button>
      <button
        type="button"
        :style="{ backgroundColor: '#0A66C2' }"
        class="h-[48px] w-[48px] flex justify-center items-center"
        @click="share(`http://www.linkedin.com/shareArticle?url=`)"
        aria-label="linkedin"
        tabindex="7"
      >
        <MyIcon
          icon="mdiLinkedin"
          color="#ffffff"
          class="hover:scale-125 duration-500"
        />
      </button>
      <button
        type="button"
        :style="{ backgroundColor: '#d92856' }"
        class="h-[48px] w-[48px] flex justify-center items-center"
        name="instagram"
        @click="copy"
        aria-label="instagram"
        tabindex="8"
      >
        <MyIcon
          icon="mdiInstagram"
          color="#ffffff"
          class="hover:scale-125 duration-500"
        />
      </button>
      <button
        type="button"
        :style="{ backgroundColor: '#ffffff' }"
        class="h-[48px] w-[48px] flex justify-center items-center"
        @click="copy"
        tabindex="9"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/9/9d/Threads_%28app%29_logo.svg"
          alt="threads"
          class="w-[24px] hover:scale-125 duration-500"
        />
      </button>
    </div>
  </div>
</template>
